import React from 'react';
import {RequestsInterface} from "../../controller/AdminController";
import RequestController, {TagIcon} from "./RequestController";
import {PaperLayout} from "../../components/styled/PaperLayout";
import NoData from "../../modules/form/components/NoData";
import TitleHeader from "../../components/view/TitleHeader";

interface RequestListInterface {
    status?: string;
    requests: Array<RequestsInterface>;
}

const RequestTitle: Record<string,string> = {
    pending: 'Richieste Modifica Consenso in Lavorazione',
    approved: 'Richieste Modifica Consenso Approvate',
    rejected: 'Richieste Modifica Consenso Respinte'
};

const RequestList: React.FC<RequestListInterface> = (props) => {
    const status = props.status ?? '';
    const icon = TagIcon[status]({fontSize: '1.3rem', color: 'green'}) ?? <></>;
    return (
        <PaperLayout asCard={true}>
            <TitleHeader color={'green'} fontSize={'1.2rem'} title={RequestTitle[status]} icon={icon}/>
        {
            props.requests.length > 0 ? props.requests.map((request: RequestsInterface, i: number)=> {
                return <RequestController key={i} request={request}/>
            }) :  <NoData description={'Nessun Risultato'}/>
        }
        </PaperLayout>
    )
};

export default RequestList;